import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProcessSteps } from '../components/ProcessSteps';
import { CapabilitiesVideo } from '../components/CapabilitiesVideo';
import { Expertise } from '../components/Expertise';
import { Materials } from '../components/Materials';
import { Partnership } from '../components/Partnership';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { ChatWidget } from '../components/ChatWidget';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-422">
      <Header data-id="element-423" />
      <main data-id="element-424">
        <Hero data-id="element-425" />
        <Expertise data-id="element-426" />
        <ProcessSteps data-id="element-427" />
        <CapabilitiesVideo data-id="element-428" />
        <Materials data-id="element-429" />
        <Partnership data-id="element-430" />
        <Contact data-id="element-431" />
      </main>
      <Footer data-id="element-432" />
      <ChatWidget data-id="element-433" />
    </div>;
}